export const JIT_MIGRATION_LAST_SHOWN_KEY = 'jitMigrationModalLastShown';
export const JIT_MIGRATION_DISMISSED_ORDER_PREFIX = 'jitMigrationDismissedOrder_';

/**
 * CIAM migration nudge ladder state. Names match the MAUI preference keys so the two clients can be
 * reasoned about together. All three live in localStorage; the timestamp is epoch milliseconds.
 */
export const CIAM_NUDGE_DISMISSAL_COUNT_KEY = 'ciamNudgeDismissalCount';
export const CIAM_NUDGE_LAST_DISMISSED_KEY = 'ciamNudgeLastDismissedAt';
export const CIAM_NUDGE_BUDGET_EXHAUSTED_KEY = 'ciamNudgeBudgetExhausted';
